





























































































































































































import Vue from "vue";
import Component from "vue-class-component";
import TextMonthChangePicker from "./TextMonthChangePicker.vue";
import {
  SearchCondition,
  zenkana2Hankana,
  hiraToKana,
  getStorageNumber
} from "@/types";
import { Prop, Emit, Watch, Ref } from "vue-property-decorator";
import RadioGroupDialog from "@/components/common/RadioGroupDialog.vue";

interface StringKeyObject {
  [key: string]: object;
}

@Component({
  components: {
    TextMonthChangePicker,
    RadioGroupDialog
  }
})
export default class BaseTable extends Vue {
  @Prop({ default: "" }) yearmonth!: string;

  @Prop() btnText!: string;

  @Prop() btnOutputText!: string;

  @Prop() btnDownloadText!: string;

  @Prop({ default: "請求データ削除" }) btnDeleteDataText!: string;

  @Prop({ default: "明細データ確定" }) checkText!: string;

  @Prop() items!: StringKeyObject[];

  @Prop() headers!: object[];

  @Prop({ default: true }) useChecked!: boolean;

  @Prop({ required: true }) storageKeyPrefix!: string;

  // セッションストレージ保存キー
  @Prop({ default: "", required: false }) storageKeyItemChecks!: string;

  @Ref("previewTypeDialog")
  private readonly previewTypeDialog!: RadioGroupDialog;

  private searchCondition: SearchCondition = {
    isDone: false,
    insuranceNo: "",
    insuranceName: "",
    userCode: "",
    userKana: "",
    userInsNo: ""
  };
  private selectItems: StringKeyObject[] = [];
  private sortBy: string[] = [];
  private sortDesc: boolean[] = [];
  private isFixed = false;
  private filterWord = ""; //絞り込み文字列
  SPECIFICATION = 0;
  INVOICE = 1;
  MERGE = 2;

  private get position() {
    if (this.isFixed) {
      return "fixed";
    } else {
      return "initial";
    }
  }

  private datatable: HTMLElement | null = null;
  private spacer: HTMLElement | null = null;
  private conditionArea: HTMLElement | null = null;
  private datatableWrapper: HTMLElement | null = null;
  private table: HTMLElement | null = null;
  private thead: HTMLElement | null = null;
  private normalWidths: string[] = [];
  private fixWidths: string[] = [];

  mounted() {
    this.initField();
  }

  beforeDestroy() {
    window.onresize = null;
    window.onscroll = null;
    if (this.datatableWrapper != null) {
      this.datatableWrapper.onscroll = null;
    }
  }

  public updateBaseTable() {
    if (this.table && this.datatableWrapper && this.thead) {
      //内容に合わせて、fix時ヘッダーの幅取得
      this.getWidthFixHeader();
      this.adjustTable();

      //スクロール時
      window.onscroll = () => {
        this.scrollHeader();
        this.adjustTable();
      };

      //リサイズ時
      window.onresize = () => {
        this.initField();
        this.getWidthFixHeader();
        this.adjustTable();
      };

      //横スクロール時
      this.datatableWrapper.onscroll = () => {
        this.scrollHeader();
      };
    }
  }

  //テーブルの高さを調整する
  private adjustTable() {
    if (
      this.datatable == null ||
      this.datatableWrapper == null ||
      this.table == null ||
      this.spacer == null ||
      this.conditionArea == null ||
      this.thead == null
    ) {
      return;
    }

    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    const scrollTop = window.scrollY;
    const conditionHeight = this.conditionArea.clientHeight + 16;
    const tableHeight = this.table.clientHeight;

    if (scrollTop > conditionHeight - 88) {
      if (!this.isFixed) {
        this.setWidthFixHeader();
        this.isFixed = true;
      }
    } else {
      if (this.isFixed) {
        this.setWidthNormalHeader();
        this.isFixed = false;
      }
    }

    let headerLength = 56;
    if (windowWidth > 960) {
      headerLength += 8;
    }
    let baseHeight = headerLength + 12 + 16 + 12 + 9;
    if (this.isFixed) {
      baseHeight += 48;
    }

    const nowHeight = windowHeight - conditionHeight - baseHeight + scrollTop;
    if (nowHeight < tableHeight) {
      this.datatable.style.height = nowHeight + "px";
      this.spacer.style.height = tableHeight - nowHeight + "px";
    } else {
      this.datatable.style.height = "auto";
      this.spacer.style.height = "0px";
    }
  }

  //ヘッダーを横スクロールする
  private scrollHeader() {
    if (this.thead && this.datatableWrapper) {
      this.thead.scrollLeft = this.datatableWrapper.scrollLeft;
    }
  }

  //固定ヘッダーの幅を設定する
  private setWidthFixHeader() {
    if (this.thead) {
      const thgroup = this.thead.children[0] as HTMLElement;
      thgroup.style.display = "inline-block";
      thgroup.style.width = "max-content";
      for (let index = 0; index < this.fixWidths.length; index++) {
        const th = thgroup.children[index] as HTMLElement;
        if (th && thgroup.children.length === this.fixWidths.length) {
          th.style.width = this.fixWidths[index];
        }
      }
    }
  }

  //固定ヘッダーの幅を所得する
  private getWidthFixHeader() {
    if (this.table && this.thead && this.datatableWrapper) {
      //ヘッダーの幅調整
      this.thead.style.width = this.datatableWrapper.clientWidth + "px";

      //固定ヘッダーの幅取得 && 固定ヘッダー時のtbodyの幅設定
      const tbody = this.table.children[2] as HTMLElement;
      const tdgroup = tbody.children[0];
      this.fixWidths = [];
      for (let index = 0; index < this.normalWidths.length; index++) {
        const td = tdgroup.children[index] as HTMLElement;
        if (td && tdgroup.children.length == this.normalWidths.length) {
          td.style.width = this.normalWidths[index];
          td.style.minWidth = this.normalWidths[index];
          this.fixWidths.push(td.clientWidth + "px");
        }
      }
    }
  }

  //通常ヘッダーの幅を設定する
  private setWidthNormalHeader() {
    if (this.thead) {
      const thgroup = this.thead.children[0] as HTMLElement;
      thgroup.style.display = "";
      thgroup.style.width = "";
      for (let index = 0; index < this.normalWidths.length; index++) {
        const th = thgroup.children[index] as HTMLElement;
        if (th && thgroup.children.length === this.normalWidths.length) {
          th.style.width = this.normalWidths[index];
        }
      }
    }
  }

  //変数elementを設定する
  private initField() {
    this.datatable = window.document.getElementById("data-table");
    this.spacer = window.document.getElementById("spacer");
    this.conditionArea = window.document.getElementById("condition-area");
    if (this.datatable && this.spacer && this.conditionArea) {
      this.datatableWrapper = this.datatable
        .firstElementChild as HTMLElement | null;
      if (this.datatableWrapper) {
        this.table = this.datatableWrapper
          .firstElementChild as HTMLElement | null;
        if (this.table) {
          this.thead = this.table.children[1] as HTMLElement;
          const thgroup = this.thead.children[0];
          this.normalWidths = [];
          for (let index = 0; index < thgroup.children.length; index++) {
            const th = thgroup.children[index] as HTMLElement | null;
            if (th) {
              this.normalWidths.push(th.style.width);
            }
          }
        }
      }
    }
  }

  @Emit()
  private search(): SearchCondition {
    return this.searchCondition;
  }

  @Emit()
  private edit(item: object): object {
    return item;
  }

  //並び替えをした選択アイテム配列
  private get filterSelectItems() {
    if (this.sortBy.length < 1) {
      return this.selectItems;
    }
    const col = this.sortBy[0];
    const desc = this.sortDesc[0];
    const newArray: StringKeyObject[] = this.selectItems.slice(
      0,
      this.selectItems.length
    );
    newArray.sort((x: StringKeyObject, y: StringKeyObject) => {
      if (desc) {
        if (x[col] < y[col]) {
          return 1;
        } else if (x[col] == y[col]) {
          return 0;
        } else {
          return -1;
        }
      } else {
        if (x[col] < y[col]) {
          return -1;
        } else if (x[col] == y[col]) {
          return 0;
        } else {
          return 1;
        }
      }
    });
    return newArray;
  }

  //プレビュータイプを元にcsv出力する
  private done(type: number) {
    localStorage.setItem(
      `${this.storageKeyPrefix}-preview-type`,
      type.toString()
    );
    switch (type) {
      case this.SPECIFICATION:
        this.$emit("done-specification", this.filterSelectItems);
        break;
      case this.INVOICE:
        this.$emit("done-insinvoice", this.filterSelectItems);
        break;
      case this.MERGE:
        this.$emit("done-all", this.filterSelectItems);
        break;
    }
  }

  //PDFプレビュークリック
  private openPreviewDialog() {
    if (this.confirmAllSelect()) {
      const type = getStorageNumber(`${this.storageKeyPrefix}-preview-type`);
      this.previewTypeDialog.open(type);
    }
  }

  //最終出力処理
  private output() {
    if (this.confirmAllSelect()) {
      this.$emit("output", this.filterSelectItems);
    }
  }

  //確定
  private checked() {
    if (this.confirmAllSelect()) {
      this.$emit("checked", this.selectItems);
    }
  }

  //未確定
  private cancel() {
    if (this.confirmAllSelect()) {
      this.$emit("cancel", this.selectItems);
    }
  }

  //ダウンロード
  private download() {
    if (this.confirmAllSelect()) {
      this.$emit("download", this.selectItems);
    }
  }

  //請求データ削除
  private deletedata() {
    this.$emit("deletedata", this.selectItems);
  }

  get innerYearmonth(): string {
    return this.yearmonth;
  }

  set innerYearmonth(newValue) {
    this.$emit("update:yearmonth", newValue);
  }

  public setSearchCondition(searchCondition: SearchCondition) {
    this.searchCondition = searchCondition;
  }

  public getSearchCondition(): SearchCondition {
    return this.searchCondition;
  }

  public refreshSelectItem() {
    this.selectItems = [];
  }

  //チェックがついているか確認
  private confirmAllSelect(): boolean {
    if (this.selectItems.length === 0) {
      if (
        confirm(
          "チェックがついていません。表示されている全てを対象に処理を行いますか？"
        )
      ) {
        this.selectItems = this.items;
        return true;
      }
      return false;
    }
    return true;
  }

  //絞りこみ条件入力監視
  @Watch("filterWord")
  handle() {
    this.$nextTick(() => {
      this.getWidthFixHeader();
      this.adjustTable();
    });
  }

  //絞り込み条件
  private customFilter(value: any, search: string | null, item: any) {
    return (
      value != null &&
      search != null &&
      typeof value === "string" &&
      zenkana2Hankana(hiraToKana(value.replaceAll(" ", ""))).indexOf(
        zenkana2Hankana(hiraToKana(search.replaceAll(" ", "")))
      ) !== -1
    );
  }

  //アイテムの色を変更
  private itemClass(item: any) {
    if (item.is_exec !== "") {
      return "complete";
    }
  }

  //------------------------------------------
  // アイテムのチェック状態が変更になったイベント
  //------------------------------------------
  private onItemChecked(items: any[]) {
    this.saveStorage(items);
  }
  //------------------------------------------
  // チェック状態解除
  //------------------------------------------
  public clearAllCheck() {
    this.selectItems.splice(0);
    this.removeStorage();
  }
  //------------------------------------------
  // 検索条件セッションストレージ削除メソッド
  //------------------------------------------
  private removeStorage() {
    if (this.storageKeyItemChecks === "") {
      return;
    }
    sessionStorage.removeItem(this.storageKeyItemChecks);
  }
  //------------------------------------------
  // 検索条件セッションストレージ保存メソッド
  //------------------------------------------
  private saveStorage(items: any[]) {
    if (this.storageKeyItemChecks === "") {
      return;
    }
    const ids: number[] = [];
    items.forEach(elm => {
      ids.push(elm.id);
    });
    if (ids.length === 0) {
      this.removeStorage();
      return;
    }
    sessionStorage.setItem(this.storageKeyItemChecks, ids.toString());
  }
  //------------------------------------------
  // 検索条件セッションストレージ復帰メソッド
  //------------------------------------------
  public restoreStorage() {
    if (this.storageKeyItemChecks === "") {
      return;
    }
    const str = sessionStorage.getItem(this.storageKeyItemChecks);
    if (str == null || str == "") {
      return;
    }
    let ids: number[] = [];
    if (str) {
      ids = str.split(",").map(Number);
    }
    this.refreshSelectItem();
    this.items.forEach(elm => {
      ids.forEach(n => {
        if ((elm.id as any) == n) {
          this.selectItems.push(elm);
        }
      });
    });
  }
}
